import React, { useEffect } from "react";
import MainLayout from "Screens/components/MainLayout";
import MainPara from "Screens/components/MainPara";
import EmailSender from "Screens/components/EmailSender";
import { useDispatch, useSelector } from "react-redux";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { get_social } from "http/components/Requests";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { set_SocialData } from "../../Redux/slices/dataSlice";

export default function ContactusIndex() {
  const dispatch = useDispatch();
  const { social } = useSelector((state) => ({
    social: state.data.social,
  }));

  useEffect(() => {
    getSocialData();
  }, []);

  const getSocialData = async () => {
    dispatch(HandleLoading(true));
    const social_response = await get_social();
    if (CheckApiStatus(social_response))
      dispatch(set_SocialData(social_response.data));
    dispatch(HandleLoading(false));
  };

  return (
    <MainLayout
      pageContent={
        <>
          <MainPara
            title={"contactusTitle"}
            text={"contactusText"}
            social={social && social.infos}
          />
          <EmailSender />
        </>
      }
      imageSrc={social && social.image}
      imageAlt={"ContactPageImage"}
    />
  );
}
